import { Outlet } from "react-router-dom";

const ScreenLanding = () => {
    return <Outlet />
}

export default ScreenLanding;